import { ObservableMap } from '@stencil/store';

import { Tenant } from '../../models/tenant';
import Logger from '../../utils/logger/logger';
import { currentTenantStorageKey } from '../../utils/storageKeys';
import { setMenuItems } from '../common';
import { State } from '../types/state';

export function setCurrentTenantInfoSideEffect(store: ObservableMap<State>) {
    store.onChange('currentTenantInfo', (tenant?: Tenant) => {
        Logger.debug('store', 'current tenant has changed', { object: tenant });

        if (tenant) {
            Logger.debug('store', 'tenant has changed: ' + tenant.name);
            store.set('currentTenant', tenant.name);

            // emit the tenant changed event only on actual change
            const tenantChangedEmitter = store.get('tenantChangedEmitter');
            const lastEmittedTenant = store.get('lastEmittedTenant');
            Logger.debug(
                'store',
                'lastEmittedTenant: ' +
          lastEmittedTenant +
          ', tenant.name: ' +
          tenant.name,
            );
            if (
                (lastEmittedTenant == null || lastEmittedTenant !== tenant.name) &&
        tenantChangedEmitter
            ) {
                tenantChangedEmitter?.emit({
                    selectedTenantId: tenant.name,
                    id: tenant.id,
                    name: tenant.name,
                });
                Logger.debug('store', 'tenant changed event emitted', { object: tenant });
                store.set('lastEmittedTenant', tenant.name);
                localStorage.setItem(currentTenantStorageKey, tenant.name);

                Logger.debug('pendo', 'updating tenant id');
                window.PortalShell.Pendo.updateVisitorOptions({ activeTenantId: tenant.id });
            }
        }

        // updating the menuItems
        setMenuItems(store);
    });
}
